import { render, staticRenderFns } from "./workerDetail.vue?vue&type=template&id=6ababbac&scoped=true"
import script from "./workerDetail.vue?vue&type=script&lang=js"
export * from "./workerDetail.vue?vue&type=script&lang=js"
import style0 from "./workerDetail.vue?vue&type=style&index=0&id=6ababbac&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"
import style1 from "./workerDetail.vue?vue&type=style&index=1&id=6ababbac&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ababbac",
  null
  
)

export default component.exports